import { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import Actionbar from 'src/components/common/actionbar/Authactionbar';
import { Message } from 'src/components/common/form/Message';
import useUiuxStore from 'src/store/useUiuxStore';
import { useMouseContent } from 'src/utils/mouse/mouseContent';
import { Content_SAL3050_R01 } from './Content_SAL3050_R01';
import { SearchSection_SAL3050_R01 } from './SearchSection_SAL3050_R01';
import { Table_SAL3050_R01 } from './Table_SAL3050_R01';
import { DetailTable_SAL3050_R01 } from './DetailTable_SAL3050_R01';
import { useSAL3050_R01Store } from './Store_SAL3050_R01';
import { SAL3050_R01DetailDto, SAL3050_R01HeaderDto } from './Dto_SAL3050_R01';

const RESIZER = {
    code: 'SAL3050_R01',
    type: 'height',
    storageKey: 'SAL3050_R01-split-height',
    min: 5,
    max: 80,
    default: 45,
} as const;

export const Container_SAL3050_R01 = () => {
    const { initData } = useSAL3050_R01Store();
    const { tabList, setMessage } = useUiuxStore();

    const gridRef = useRef<AgGridReact<SAL3050_R01HeaderDto>>(null);
    const detailGridRef = useRef<AgGridReact<SAL3050_R01DetailDto>>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const detailRef = useRef<HTMLDivElement>(null);
    const isResizing = useRef(false);

    const { splitValue, handleMouseDown } = useMouseContent({
        resizer: RESIZER,
        isResizing,
        containerRef,
        infoRef: detailRef,
    });

    const { fetchData } = Content_SAL3050_R01({
        gridRef,
        detailGridRef,
        tabList,
        setMessage,
        containerRef,
        isResizing,
    });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onCreateClick={undefined}
                onDeleteClick={undefined}
                onSaveClick={undefined}
                onPrintClick={undefined}
                onExcelClick={undefined}
                onInitClick={initData}
            />

            <SearchSection_SAL3050_R01 />

            <div
                className="flex flex-col flex-1 p-[12px] gap-[4px] min-h-0"
                ref={containerRef}
            >
                <div className="w-full" style={{ height: `${splitValue}%` }}>
                    <Table_SAL3050_R01 gridRef={gridRef} />
                </div>

                <div
                    className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
                    onMouseDown={(e) => handleMouseDown('UD', e.nativeEvent)}
                />

                <div className="w-full" style={{ height: `${100 - splitValue}%` }} ref={detailRef}>
                    <DetailTable_SAL3050_R01 gridRef={detailGridRef} />
                </div>
            </div>

            <Message />
        </div>
    );
};
